import Vue from "vue";

const ServiceDetailProps = Vue.extend({
  props: {
    name: {
      type: String,
      default: "",
    },
    price: {
      type: String,
      default: "0",
    },
    localization: {
      type: String,
      default: "",
    },
    date: {
      type: String,
      default: "",
    },
    time: {
      type: String,
      default: "",
    },
    page: {
      type: Number,
      default: 0,
    },
    patient: {
      type: Object,
    },
  },
});

export default ServiceDetailProps;
